import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styles from "../studioInfoModule.module.css";
import NumberDisplay from "../../../../components/numberDisplay/numberDisplay";
import PercentageDisplay from "../../../../components/percentageDisplay/percentageDisplay";
import PercentageGain from "../../../../components/percentageGain/percentageGain";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faPlay);

function content(props) {
  if (props.data === null) {
    return (
      <div className={`${styles.bookingsWrapper} ${props.lightTheme && styles.bookingsWrapperLight}`}>
        <p style={{ textAlign: "center", width: "100%" }}>No data to display.</p>
      </div>
    );
  } else {
    return (
      <div className={`${styles.bookingsWrapper} ${props.lightTheme && styles.bookingsWrapperLight}`}>
        <div className={`${styles.progress}`}>
          <div className={`${styles.arrow} ${styles.arrowFirst}`}>
            ----------&nbsp;
            <span className={`${styles.percentageDisplayWrapper}`}>
              <PercentageDisplay
                showDecimal
                size={30}
                value={(props.data.bookingsShowsPercent * 100).toFixed(1)}
                url={props.data.bookingsShowsPercentRawDataLink}
              />
            </span>
            &nbsp;----------
            <FontAwesomeIcon icon="play" />
            <span className={`${styles.percentageGainWrapperArrow} ${styles.percentageGainWrapperArrowFirst}`}>
              <PercentageGain value={(props.data.bookingsShowsPercentChange * 100).toFixed(1)} />
            </span>
          </div>
          <h2 className={`${styles.title}`}>Intros Booked</h2>
          <span className={`${styles.bookingsNumberWrapper}`}>
            <NumberDisplay value={props.data.introsBooked} url={props.data.introsBookedRawDataLink} />
            <span className={`${styles.percentageGainWrapper}`}>
              <PercentageGain value={(props.data.introsBookedChange * 100).toFixed(1)} url={props.data.classConversionRatePercentRawDataLink} />
            </span>
          </span>
        </div>
        <div className={`${styles.progress}`}>
          <div className={`${styles.arrow} ${styles.arrowSecond}`}>
            ----------&nbsp;
            <span className={`${styles.percentageDisplayWrapper}`}>
              <PercentageDisplay
                showDecimal
                size={30}
                value={(props.data.classConversionRatePercent * 100).toFixed(1)}
                url={props.data.classConversionRatePercentRawDataLink}
              />
            </span>
            &nbsp;----------
            <FontAwesomeIcon icon="play" />
            <span className={`${styles.percentageGainWrapperArrow} ${styles.percentageGainWrapperArrowSecond}`}>
              <PercentageGain value={(props.data.classConversionRatePercentChange * 100).toFixed(1)} />
            </span>
          </div>
          <h2 className={`${styles.title}`}>Booking Shows</h2>
          <span className={`${styles.bookingsNumberWrapper}`}>
            <span className={`${styles.bookingsNumberWrapper}`}>
              <NumberDisplay size={46} value={props.data.bookingsShows} url={props.data.bookingsShowsPercentRawDataLink} />
            </span>
          </span>
        </div>
        <div className={`${styles.progress}`}>
          <h2 className={`${styles.title}`}>Class Conversion</h2>
          <span className={`${styles.bookingsNumberWrapper}`}>
            <span className={`${styles.bookingsNumberWrapper}`}>
              <NumberDisplay size={46} value={props.data.numberOfClassConversion} url={props.data.classConversionRatePercentRawDataLink} />
            </span>
          </span>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  data: state.studioInfo.introsBooked.data
}))(content);

content.propTypes = {
  data: PropTypes.object.isRequired,
  lightTheme: PropTypes.bool
};
